
		import async from 'preact-cli/async-component';

		function load(cb) {
			require.ensure([], function(require) {
				cb(require("!!../../../node_modules/babel-loader/lib/index.js??ref--0!./index.js"));
			}, "route-settings");
		}

		export default async(load);
	


//////////////////
// WEBPACK FOOTER
// ./routes/settings/index.js
// module id = DOz/
// module chunks = 12